import React, { useEffect, useState } from 'react'
import { TablePagination } from '../../../../../components/table'
import { useRESTapi } from '../../../../../hooks/rest_API'
import { Product, ProductItem, ProductItemKeys, ProductKeys, Warehouse, WarehouseKeys, pagination } from '../../../../../types'
import { AddWarehouseModal } from './component/addmodal'
import { useNavigate } from 'react-router-dom'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/src/components/ui/table'
import { Button } from '@/src/components/ui/button'
import { ButtonIcon } from '@/src/components/buttons/buttonIcon'
import { Pencil, Trash } from 'lucide-react'
import { useAlertModal } from '@/src/hooks/alert_modal'
import { SkeletonTableAdmin } from '../../../components/skeltonTable'
import { DeleteModal } from './component/deleteModal'

interface productSKUList extends ProductItem {
  delete: any,
  edit: any,
  page_number: number
}

export function WarehouseDetails() {

  const [warehouse, set_warehouse] = useState<(Warehouse & { page_number: number, delete: any, edit: any })[]>([])
  const [mode, set_mode] = useState<'edit' | 'add'>('add')
  const api = useRESTapi()
  const [update, setUpdate] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [selectedEmployeeId, set_selected_product] = useState<string>()
  const [page_selected, set_page_selected] = useState<number>(1)
  const [products_total, set_warehouse_total] = useState<number>(1)
  const [per_page, set_per_page] = useState<number>(30)
  const [isLoadingWarehouse, setLoadingWarehosue] = useState(false)
  const navigate = useNavigate()
  const alertModal = useAlertModal();
  const [showDeleteModal, setshowDeleteModal] = useState(false)
  const [isDeleteoading, setIsDeleteLoading] = useState(false)

  const header: {
    label: WarehouseKeys | string,
    name: string
  }[] = [
      {
        label: 'page_number',
        name: "No"
      },
      {
        label: WarehouseKeys.I01_Warehouse_name,
        name: "name"
      },
      {
        label: WarehouseKeys.I01_Warehouse_capacity,
        name: "capacity"
      },
      {
        label: 'edit',
        name: ''
      },
      {
        label: 'delete',
        name: ''
      },
    ]

  const updateUi = () => {
    setUpdate(!update)
  }

  async function delete_product(id: number | string) {

    try {
      setIsDeleteLoading(true)
      const res = await api.Delete<{ success: boolean, data: Warehouse[], message: string }>({
        url: `${process.env.REACT_APP_BACKEND_URL_ADMIN!}/warehouse/${id}`,
        mode: 'admin'
      })
      updateUi();
      if (res.data.success) {
        alert(res.data.message)
        setIsDeleteLoading(false)
        setshowDeleteModal(false)
      } else {
        alert(res.data.message)
        setIsDeleteLoading(false)

      }


    } catch (error) {
      console.log(error)
      alert('Server error')
      setIsDeleteLoading(false)
    }

  }

  function clickEditButton(id: string) {
    set_selected_product(id)
    setShowModal(true)
    set_mode('edit')
  }
  function open_add_modal() {
    set_selected_product(undefined)
    setShowModal(true)
    set_mode('add')
  }

  useEffect(
    () => {

      const initData = async () => {

        setLoadingWarehosue(true)
        try {
          const res = await api.get<{ success: boolean, data: { data: (Warehouse & { page_number: number, delete: any, edit: any })[] } & pagination }>({
            url: `${process.env.REACT_APP_BACKEND_URL_ADMIN!}/warehouse`,
            mode: 'admin',
            params: {
              perPage: per_page,
              page: page_selected
            }
          })

          if (res.data.success === true) {
            // console.log(res.data)
            set_warehouse(res.data.data.data.map(
              (item, index) => {
                item.page_number = ((page_selected - 1) * per_page) + (index + 1)
                item.delete = <ButtonIcon icon={<Trash className="h-4 w-4" />} onClick={(e) => { e?.stopPropagation(); set_selected_product(String(item.I01_Warehouse_Id)); setshowDeleteModal(true) }}></ButtonIcon>
                item.edit = <ButtonIcon icon={<Pencil className="h-4 w-4" />} onClick={(e) => { e?.stopPropagation(); clickEditButton(String(item.I01_Warehouse_Id)) }}></ButtonIcon>
                return item;
              }
            ))
            set_warehouse_total(res.data.data.total)
            setLoadingWarehosue(false)
          } else {
            alertModal.open_alert_modal({
              content: 'Server error',
              footer: <div className=' flex'>
                <Button onClick={alertModal.close_alert_modal} variant={'outline'}>Cancel</Button>
                <Button onClick={alertModal.close_alert_modal}>Ok</Button>
              </div>,
              title: 'Error'
            })
          }
        } catch (error) {
          console.log(error)
          alertModal.open_alert_modal({
            content: 'Server error',
            footer: <div className=' flex'>
              <Button onClick={alertModal.close_alert_modal} variant={'outline'}>Cancel</Button>
              <Button onClick={alertModal.close_alert_modal}>Ok</Button>
            </div>,
            title: 'Error'
          })
        }

      }

      initData()

    }, [update]
  )

  return (
    <div className='  w-full h-full flex flex-col items-center  overflow-auto py-10 gap-2 px-5 '>
      <AddWarehouseModal
        id={selectedEmployeeId}
        show={showModal}
        closeModal={() => setShowModal(false)}
        updateUi={updateUi}
        mode={mode}
        setShow={setShowModal}
      />
      <DeleteModal
        show={showDeleteModal}
        setShow={setshowDeleteModal}
        onDelete={async () => {
          await delete_product(selectedEmployeeId!);
        }}
        isDeleteing={isDeleteoading}
      />
      <div className=' p-2 text-2xl font-bold'>Warehouse List</div>
      <div className=' w-full flex justify-end' >
        <Button onClick={open_add_modal} className=' '>Add Warehouse</Button>
      </div>
      <div className=' overflow-auto  w-full border rounded-md'>
        {
          isLoadingWarehouse ?
            <SkeletonTableAdmin />
            :
            <Table>
              <TableHeader>
                <TableRow>
                  {
                    header.map(
                      (header, index) => <TableHead key={index}>{header.name}</TableHead>
                    )
                  }
                </TableRow>
              </TableHeader>
              <TableBody>
                {
                  warehouse.length === 0
                    ?
                    'No data'
                    :
                    warehouse.map(
                      (row: any, index) => (
                        <TableRow key={index} className=' cursor-pointer' onClick={() => navigate(`${row.I01_Warehouse_Id}`)} >
                          {
                            header.map(
                              (header, index) => <TableCell key={index}>{row[header.label]}</TableCell>
                            )
                          }
                        </TableRow>
                      )
                    )

                }
              </TableBody>
            </Table>
        }
      </div>
      <div>
        <TablePagination totalRows={products_total} rowsPerPage={per_page} onClickIndex={(e) => { set_page_selected(e); updateUi() }} selectedPage={page_selected} />
      </div>
    </div>
  )
}
